import { render, staticRenderFns } from "./fl223-new-proposal-action-button.vue?vue&type=template&id=4be6c468&"
import script from "./fl223-new-proposal-action-button.vue?vue&type=script&lang=js&"
export * from "./fl223-new-proposal-action-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/stage-dev1/front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4be6c468')) {
      api.createRecord('4be6c468', component.options)
    } else {
      api.reload('4be6c468', component.options)
    }
    module.hot.accept("./fl223-new-proposal-action-button.vue?vue&type=template&id=4be6c468&", function () {
      api.rerender('4be6c468', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/global/fl223-notices/partials/fl223-new-proposal-action-button.vue"
export default component.exports